// Popular countries list with emojis
export const COUNTRIES = [
  "🇺🇸 United States",
  "🇬🇧 United Kingdom",
  "🇨🇦 Canada",
  "🇦🇺 Australia",
  "🇫🇷 France",
  "🇮🇹 Italy",
  "🇪🇸 Spain",
  "🇩🇪 Germany",
  "🇯🇵 Japan",
  "🇰🇷 South Korea",
  "🇨🇳 China",
  "🇮🇳 India",
  "🇧🇷 Brazil",
  "🇲🇽 Mexico",
  "🇦🇷 Argentina",
  "🇨🇱 Chile",
  "🇨🇴 Colombia",
  "🇵🇪 Peru",
  "🇳🇱 Netherlands",
  "🇧🇪 Belgium",
  "🇨🇭 Switzerland",
  "🇦🇹 Austria",
  "🇸🇪 Sweden",
  "🇳🇴 Norway",
  "🇩🇰 Denmark",
  "🇫🇮 Finland",
  "🇮🇸 Iceland",
  "🇮🇪 Ireland",
  "🇵🇹 Portugal",
  "🇬🇷 Greece",
  "🇹🇷 Turkey",
  "🇪🇬 Egypt",
  "🇿🇦 South Africa",
  "🇰🇪 Kenya",
  "🇲🇦 Morocco",
  "🇦🇪 UAE",
  "🇸🇦 Saudi Arabia",
  "🇮🇱 Israel",
  "🇹🇭 Thailand",
  "🇻🇳 Vietnam",
  "🇸🇬 Singapore",
  "🇲🇾 Malaysia",
  "🇮🇩 Indonesia",
  "🇵🇭 Philippines",
  "🇳🇿 New Zealand",
  "🇫🇯 Fiji",
  "🇷🇺 Russia",
  "🇺🇦 Ukraine",
  "🇵🇱 Poland",
  "🇨🇿 Czech Republic",
  "🇭🇺 Hungary",
  "🇷🇴 Romania",
  "🇭🇷 Croatia",
  "🇬🇾 Guyana",
  "🇯🇲 Jamaica",
  "🇧🇧 Barbados",
  "🇹🇹 Trinidad and Tobago",
  "🇨🇷 Costa Rica",
  "🇵🇦 Panama",
  "🇪🇨 Ecuador",
  "🇺🇾 Uruguay",
  "🇵🇾 Paraguay",
  "🇧🇴 Bolivia",
  "🇻🇪 Venezuela"
];
